import React from "react";
import FooterStyles from "./Footer.module.css";

const Footer = () => {
  return (
    <footer className={FooterStyles.main}>&copy;The Glitch UI 2020</footer>
  );
};

export default Footer;
